import { useCallback } from 'react';
import { signUp } from '../../redux/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from '../../redux';

interface CreateCognitoPayload {
  given_name: string;
  family_name: string;
  practice_id: string;
  email: string;
  role: string;
  password: string;
}

const useCognitoSignUp = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const { cognito, loading, error } = useSelector((state: RootState) => state.auth);

  const handleCreateUser = useCallback(
    async (userData: CreateCognitoPayload): Promise<boolean> => {
      try {
        await dispatch(signUp(userData));
        return true;
      } catch (error) {
        console.error('Failed to create user:', error);
        return false;
      }
    }, 
    [dispatch]
  );

  return { handleCreateUser, cognito, loading, error };
};

export default useCognitoSignUp;